import * as React from 'react';
import { defaultRender } from 'piral-core';
export const DefaultContainer = (props) => defaultRender(props.children);
export const DefaultResult = (props) => defaultRender(props.children);
export const DefaultInput = (props) => (React.createElement("input", { onChange: (e) => props.setValue(e.target.value), value: props.value }));
//# sourceMappingURL=default.js.map